module.exports = __webpack_public_path__ + "media/images/badges/ocean_stewardship-100-f6dca7b47153a757626cfedef572a4c7.svg";